// extracted by mini-css-extract-plugin
export default {"contenedor":"LateralMenu_contenedor__O7lbx","listadoLateralMenu":"LateralMenu_listadoLateralMenu__FBxaY","menuSeleccionado":"LateralMenu_menuSeleccionado__enX6h"};